import styled from 'styled-components';

interface WrapperProps {
  $aspectRatio: string;
  $strokeWidth: number;
}

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  width: 100%;
  aspect-ratio: ${({ $aspectRatio }) => $aspectRatio.replace(':', '/')};
  border: ${({ $strokeWidth }) => $strokeWidth}px solid var(--t-brand-fg-color);
  overflow: hidden;

  > * {
    width: 100%;
    height: 100%;
  }
`;
